import { useParams } from 'react-router-dom';
import { resolveDocType } from '../utils/docCategory';
import { useReaderEntity } from './useReaderEntity';

/**
 * The doc type of the current reader page, or `undefined` outside a reader
 * page and on a page that is not a category doc.
 */
export function useReaderDocType(): string | undefined {
  const { entity } = useReaderEntity();
  const { '*': path = '' } = useParams();

  return resolveDocType(entity, path);
}
